<template>
  <component
    :is="tag"
    v-preserve-properties="bindings"
    class="finder-results-card"
    :data-result-guid="result.resultGUID"
  ></component>
</template>

<script setup>
import { computed } from "vue";
import { vPreserveProperties } from "#ce/utils/property-bindings";

const props = defineProps({
  tag: {
    type: String,
    required: true,
  },
  result: {
    type: Object,
    required: true,
  },
  /**
   * The properties the finder's kind hands the element besides `result`.
   *
   * @type {Object}
   */
  properties: {
    type: Object,
    default: () => ({}),
  },
});

const bindings = computed(() =>
  Object.fromEntries(
    Object.entries({ result: props.result, ...props.properties }).map(([name, value]) => [`.${name}`, value]),
  ),
);
</script>
